var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErrored && _vm.type === 1 && _vm.allowVideoFallback)?_c('video',{attrs:{"src":_vm.videoURL}}):_c('img',{attrs:{"src":_vm.thumbnailURL},on:{"error":_vm.thumbnailLoadError}})}
var staticRenderFns = []

export { render, staticRenderFns }